/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import {
  getPendingUploads,
  getRunningUploads,
  getRunningCount,
} from 'bucket/reducers/uploads';
import { cancelPending } from 'bucket/actions/uploads';
import UploadList from './components/UploadList';
import PendingUploads from './components/PendingUploads';

type Props = {
  running: List<RunningUpload>,
  pending: List<PendingUpload>,
  runningCount: number,
  cancelPending: () => void,
};

const mapStateToProps = state => ({
  running: getRunningUploads(state),
  pending: getPendingUploads(state),
  runningCount: getRunningCount(state),
});

const Upload = ({ running, pending, runningCount, cancelPending }: Props) => (
  <div>
    <UploadList uploads={running} runningCount={runningCount} />
    <PendingUploads count={pending.size} onCancel={cancelPending} />
  </div>
);

export default connect(mapStateToProps, {
  cancelPending,
})(Upload);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/index.js